// constants
import { apiRouter } from "@cloudspire/legacy-shared/src/constants/router";

// libraries
import { request } from "@cloudspire/legacy-shared/src/libraries";

// normalizers
import { contactSerialize } from "../../normalizers/contact";

/**
 * Crée une demande de contact.
 */
export default async function contactCreate({ requestContext, parameterList }) {
  const route = apiRouter.findByName("App.Contact.Create").toFilled();

  return await request({
    url: route.generateUri().toString(),
    method: route.getMethods()[0],
    context: requestContext,
    type: "formData",
    body: await contactSerialize(parameterList),
  });
}
